/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Resume_BuilderInputs */

const en_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Builder`)
};

const de_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Editor`)
};

const fr_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éditeur de CV`)
};

const es_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor de currículum`)
};

const it_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor curriculum`)
};

const nl_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-editor`)
};

const pl_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytor CV`)
};

const fi_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-editori`)
};

const da_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-editor`)
};

const sv_help_resume_builder = /** @type {(inputs: Help_Resume_BuilderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-editor`)
};

/**
* | output |
* | --- |
* | "Resume Builder" |
*
* @param {Help_Resume_BuilderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_resume_builder = /** @type {((inputs?: Help_Resume_BuilderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Resume_BuilderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_resume_builder(inputs)
	if (locale === "fr") return fr_help_resume_builder(inputs)
	if (locale === "es") return es_help_resume_builder(inputs)
	if (locale === "it") return it_help_resume_builder(inputs)
	if (locale === "nl") return nl_help_resume_builder(inputs)
	if (locale === "pl") return pl_help_resume_builder(inputs)
	if (locale === "fi") return fi_help_resume_builder(inputs)
	if (locale === "da") return da_help_resume_builder(inputs)
	if (locale === "sv") return sv_help_resume_builder(inputs)
	return en_help_resume_builder(inputs)
});